import React from "react";
import bannerdipolma from "../../../../Assets/Courses/DiplomaCourse.png";

const DiplomaCourses = () => {
  return (
    <>
      <div className="w-full h-auto">
        <img
          src={bannerdipolma}
          alt="bannerdipolma"
          className="w-full h-full "
        />
      </div>
      <div className="w-full bg-white py-12 px-4 sm:px-6 lg:px-12">
        <div className="w-full text-gray-800 space-y-6 pb-10">
          {/* Heading */}
          <h3 className="text-3xl md:text-4xl font-semibold text-black mb-6 leading-snug">
            Unlock Your Potential with Our Comprehensive Diploma Courses
          </h3>

          {/* Paragraphs */}
          <p className="text-base md:text-lg leading-relaxed text-justify">
            Embark on a transformative journey of creativity and innovation with
            our Diploma Courses in Design at the International School of Design.
            Whether you dream of shaping spaces, crafting captivating visuals,
            or revolutionizing user experiences, our specialized programs offer
            hands-on training and expert guidance to help you realize your
            aspirations.
          </p>

          <p className="text-base md:text-lg leading-relaxed text-justify">
            Dive deep into the world of design, mastering essential techniques,
            industry-standard tools, and emerging trends under the mentorship of
            seasoned professionals. Elevate your skills, ignite your
            imagination, and embark on a career path filled with endless
            possibilities. Join us and embark on a path towards becoming a
            visionary designer, equipped to leave your mark on the global stage.
          </p>

          {/* Subheading */}
          <h5 className="text-2xl md:text-3xl font-semibold text-black mt-10">
            Explore Our Diverse Diploma Courses for Creative Pursuits
          </h5>

          <p className="text-base md:text-lg leading-relaxed text-justify">
            Discover a range of diploma courses tailored to unleash your
            creativity, from graphic design to fashion styling. Gain practical
            skills and industry insights for a successful career in the creative
            field.
          </p>

          {/* List Section */}
          <ul className="list-disc list-inside ml-4 space-y-2 text-base md:text-lg">
            <li>Fashion Design Diploma Course</li>
            <li>Fashion Styling Diploma Course</li>
            <li>Interior Design Diploma Course</li>
            <li>Graphic Design Diploma Course</li>
            <li>Interior Decoration &amp; Styling</li>
            <li>Diploma in Digital Marketing</li>
            <li>Diploma in Product Design and Photography</li>
          </ul>
        </div>
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 py-12 ">
          {/* Heading Section */}
          <div className="mx-auto text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 heading">
              Career Paths
            </h2>
            <p className="text-lg text-gray-600 sub-heading">
              Explore the exciting opportunities that await you
            </p>
          </div>

          {/* Card Section */}
          <div className="w-full mx-auto flex flex-col lg:flex-row gap-8 items-stretch">
            {/* Left Column */}
            <div className="w-full">
              <div className="p-8 h-full">
                <h3 className="text-2xl font-bold text-[#144982] mb-6 border-b-4 border-[#DA3335] pb-3 inline-block heading">
                  Your Future Awaits
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sub-heading">
                  {/* Card 1 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UI / UX Designer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Researcher
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UI/UX Developer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 4 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Strategist
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 5 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Consultant
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 6 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          Service Designer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 7 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Consultant
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 8 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          Product Designer
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiplomaCourses;
